// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2vLcN","signatureBlock":"Footer_signatureBlock__3Z61B","signature":"Footer_signature__2B1Ii"};